import _  from 'lodash';

import React, { Component } from 'react';
import { Button, Form, Header, Icon, Modal } from 'semantic-ui-react';

import API from '../services/api.js';

const optionsOrderType = [
	{
		key: 'Market',
		text: 'По маркету',
		value: 'Market'
	},
	{
		key: 'Limit',
		text: 'Лимитный',
		value: 'Limit'
	},
];

class AddTP extends Component {

	constructor (props) {
		super(props);

		this.state = {
			symbol: props.symbol,
			percent1: 0,
			percent2: 0,
			percent3: 0,
			valueTp1: props.position.markPrice,
			valueTp2: props.position.markPrice,
			valueTp3: props.position.markPrice,
			valueSl: 0,
			orderType: 'Market'
		};

		this.closeModal = props.closeModal;
	}

	addTP = async () => {
		const {
			symbol,
			percent1,
			percent2,
			percent3,
			valueTp1,
			valueTp2,
			valueTp3,
			valueSl,
			orderType = 'Market'
		} = this.state;

		try {
			if (valueTp1 > 0 && percent1 > 0) {
				await API.Position.addTP(symbol, {
					symbol,
					percent: percent1,
					value: valueTp1,
					stopLoss: valueSl,
					orderType,
					inPercent: false
				});
			}

			if (valueTp2 > 0 && percent2 > 0) {
				await API.Position.addTP(symbol, {
					symbol,
					percent: percent2,
					value: valueTp2,
					stopLoss: valueSl,
					orderType,
					inPercent: false
				});
			}

			if (valueTp3 > 0 && percent3 > 0) {
				await API.Position.addTP(symbol, {
					symbol,
					percent: percent3,
					value: valueTp3,
					stopLoss: valueSl,
					orderType,
					inPercent: false
				});
			}
			this.closeModal();
		} catch (err) {
			console.error(err);
		}
	};

	handleChangeNumber = (key) => async (e, { value }) => {
		await this.setState({ [key]: Number(_.trimStart(value, '0')) || 0 });
	};

	handleChange = (key) => (e, { value }) => {
		this.setState({ [key]: value });
	};

	handleFocus = (event) => event.target.select();

	render () {
		const {
			symbol,
			percent1,
			percent2,
			percent3,
			valueTp1,
			valueTp2,
			valueTp3,
			valueSl,
			orderType
		} = this.state;

		return (<>
				<Header icon="archive" content={`New order: ${symbol}`}/>
				<Modal.Content>
					<Form>
						<Form.Group widths="equal">
							<Form.Input fluid label={'1. Ордер %:'} min={0} max={100} type={'number'} placeholder="0" value={percent1}
										onFocus={this.handleFocus}
										onChange={async (e, d) => {
											await this.handleChangeNumber('percent1')(e, d);
											if (percent1 + percent2 + percent3 > 100) {
												this.setState({ percent1: 100 - percent2 - percent3 });
											}
										}}/>
							<Form.Input fluid label={'Тэйк-профит цена:'} placeholder="0" value={valueTp1}
										onFocus={this.handleFocus} onChange={this.handleChange('valueTp1')}/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Input fluid label={'2. Ордер %:'} type={'number'} placeholder="0" value={percent2}
										onFocus={this.handleFocus}
										onChange={async (e, d) => {
											await this.handleChangeNumber('percent2')(e, d);
											if (percent1 + percent2 + percent3 > 100) {
												this.setState({ percent2: 100 - percent1 - percent3 });
											}
										}}/>
							<Form.Input fluid label={'Тэйк-профит цена:'} placeholder="0" value={valueTp2}
										onFocus={this.handleFocus} onChange={this.handleChange('valueTp2')}/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Input fluid label={'3. Ордер %:'} type={'number'} placeholder="0" value={percent3}
										onFocus={this.handleFocus}
										onChange={async (e, d) => {
											await this.handleChangeNumber('percent3')(e, d);
											if (percent1 + percent2 + percent3 > 100) {
												this.setState({ percent3: 100 - percent2 - percent1 });
											}
										}}/>
							<Form.Input fluid label={'Тэйк-профит цена:'} placeholder="0" value={valueTp3}
										onFocus={this.handleFocus} onChange={this.handleChange('valueTp3')}/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Input fluid label={'Стоп-лосс цена:'} placeholder="0" value={valueSl}
										onFocus={this.handleFocus} onChange={this.handleChange('valueSl')}/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Select
								fluid
								label={'Тип ордера'}
								options={optionsOrderType}
								value={orderType}
								onChange={this.handleChange('orderType')}
							/>
						</Form.Group>`
					</Form>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={this.closeModal}>
						<Icon name="remove"/> Закрыть
					</Button>
					<Button color="green" onClick={() => this.addTP()}>
						<Icon name="checkmark"/> Добавить
					</Button>
				</Modal.Actions>
			</>
		);
	}
}

export default AddTP;
